import React from "react"
import Modal from "react-modal"
import "./layer.css"

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#000",
    border: "none",
    display: "flex",
    alignItems: "center",
  },
}

Modal.setAppElement(`#___gatsby`)
Modal.defaultStyles.overlay.backgroundColor = "rgba(0, 0, 0, 0.75)"

class Layer extends React.Component {
  render() {
    return (
      <Modal
        isOpen={this.props.open}
        style={customStyles}
        onRequestClose={() => this.props.close()}
        contentLabel="Modal"
        closeTimeoutMS={300}
      >
        {this.props.children}
      </Modal>
    )
  }
}

export default Layer
